import { USER } from "@/data/user";
import type { NavItem } from "@/types/nav";

export const SITE_INFO = {
  name: USER.displayName,
  url: process.env.APP_URL || "https://tarekhammami.com",
  ogImage: USER.ogImage,
  description: USER.bio,
  keywords: USER.keywords,
};

export const META_THEME_COLORS = {
  light: "#ffffff",
  dark: "#09090b",
};

export const MAIN_NAV: NavItem[] = [
  {
    title: "Home",
    href: "/",
  },
  {
    title: "Blog",
    href: "/blog",
  },
  // {
  //   title: "Components",
  //   href: "/components",
  // },
];

export const RESUME_URL = process.env.RESUME_URL || "https://tarekhammami.com";

export const SOURCE_CODE_GITHUB_URL =
  "https://github.com/THammami01/personal-website-v4";

export const GITHUB_USERNAME = "THammami01";

export const UTM_PARAMS = {
  utm_source: "tarekhammami.com",
  utm_medium: "portfolio_website",
  utm_campaign: "referral",
};
